import { PeriodicalFrequencyEnum } from "../types/Api";
// Mirrors backend ScheduleFamily.MANUAL — frequencies with no generable schedule
export var MANUAL_FREQUENCIES = [
    PeriodicalFrequencyEnum.IRREGULAR,
    PeriodicalFrequencyEnum.UNKNOWN,
    PeriodicalFrequencyEnum.BIENNIAL,
    PeriodicalFrequencyEnum.TRIENNIAL,
];
// Missing frequency is manual too — mirrors backend ScheduleFamily.of(null)
export var isManualFrequency = function (frequency) { return frequency == null || MANUAL_FREQUENCIES.includes(frequency); };
